// extracted by mini-css-extract-plugin
export default {"tag":"Tag-modules__tag__q97V9","canDelete":"Tag-modules__canDelete__zADAZ","deleteIcon":"Tag-modules__deleteIcon__GlUgw","show-keyframe":"Tag-modules__show-keyframe__edULb"};